/* eslint-disable import/prefer-default-export */

import React from 'react';
import { Script } from 'gatsby';

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    {process.env.GATSBY_VIDIFY_ACTION && (
      <Script
        onError={() => console.error(new Error('Failed to load vidify360 script'))}
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line no-template-curly-in-string
          // __html: "import(`https://vidify.engage.app/api/ecs/v1/loader/818638aa-dc47-4b31-a923-8e832701df35.js?path=${encodeURIComponent(window.location.toString())}&selectedVersion=${(new URLSearchParams(window.location.search)).get('ecsSelectedVersion') || ''}`)",
          __html: `
            import('https://talkative-cdn.com/spa-wrapper/1.0.0/main.js').then(() => {
              window.talkativeAdvancedWidgetApi.init({
                loaderUuid: '818638aa-dc47-4b31-a923-8e832701df35',
                region: 'vidify',
                includeQueryString: true,
                detectPageChange: false,
              });
            });
          `,
        }}
      />
    )}
  </>
);
